export default __webpack_public_path__ + "static/media/DSC04087.95a32d16.jpg";